import Vue from 'vue'
import Router from 'vue-router'
import index from '@/view/index'
import about from '@/view/about'
import air from '@/view/air'
import green from '@/view/green'
import care from '@/view/care'
import experience from '@/view/experience'
import airtest from '@/view/airtest'
import news from '@/view/news'
import join from '@/view/join'
import subscribe from '@/view/subscribe'
import faq from '@/view/faq'
import blog from '@/view/blog'
import blogDetails from '@/view/blogDetails'
import search from '@/view/search'
import information_main from '@/view/information_main'
import clause from '@/view/clause'
import privacy from '@/view/privacy'
import recruit from '@/view/recruit'
import websiteMap from '@/view/websiteMap'




Vue.use(Router)
export default new Router({
  mode: 'history', //去掉url中的#
  routes: [{
      path: '/',
      name: 'index',
      component: index,
      meta: {
        title: '主页 - Renaud蔚诺'
      }
    },
    {
      path: '/about',
      name: 'about',
      component: about,
      meta: {
        title: '关于我们 - Renaud蔚诺'
      }
    },
    {
      path: '/air',
      name: 'air',
      component: air,
      meta: {
        title: 'AIR - Renaud蔚诺'
      }
    },
    {
      path: '/green',
      name: 'green',
      component: green,
      meta: {
        title: 'Renaud蔚诺'
      }
    },
    {
      path: '/care',
      name: 'care',
      component: care,
      meta: {
        title: 'CARE - Renaud蔚诺'
      }
    },
    {
      path: '/experience',
      name: 'experience',
      component: experience,
      meta: {
        title: '2D体验馆 - Renaud蔚诺'
      }
    },
    {
      path: '/airtest',
      name: 'airtest',
      component: airtest,
      meta: {
        title: '预约空气检测 - Renaud蔚诺'
      }
    },
    {
      path: '/news',
      name: 'news',
      component: news,
      meta: {
        title: '企业资讯 - Renaud蔚诺'
      }
    },
    {
      path: '/join',
      name: 'join',
      component: join,
      meta: {
        title: '加入我们 - Renaud蔚诺'
      }
    },
    {
      path: '/subscribe',
      name: 'subscribe',
      component: subscribe,
      meta: {
        title: '订阅我们 - Renaud蔚诺'
      }
    },
    {
      path: '/faq',
      name: 'faq',
      component: faq,
      meta: {
        title: 'Renaud蔚诺'
      }
    },
    {
      path: '/blog',
      name: 'blog',
      component: blog,
      component: resovle => require(['@/view/blog'],resovle),
      meta: {
        title: 'Renaud蔚诺'
      }
    },
    {
      path: '/blogDetails',
      name: 'blogDetails',
      component: blogDetails,
      meta: {
        title: 'Renaud蔚诺'
      }
    },
    {
      path: '/search',
      name: 'search',
      component: search,
      meta: {
        title: 'Renaud蔚诺'
      }
    },
    {
      path: '/information_main',
      name: 'information_main',
      component: information_main,
      meta: {
        title: 'Renaud蔚诺'
      }
    },
    {
      path: '/clause',
      name: 'clause',
      component: clause,
      meta: {
        title: 'Renaud蔚诺'
      }
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: privacy,
      meta: {
        title: 'Renaud蔚诺'
      }
    },
    {
      path: '/recruit',
      name: 'recruit',
      component: recruit,
      meta: {
        title: 'Renaud蔚诺'
      }
    },
    {
      path: '/websiteMap',
      name: 'websiteMap',
      component: websiteMap,
      meta: {
        title: 'Renaud蔚诺'
      }
    },


  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js